module.exports = __webpack_public_path__ + "static/media/BD_WP_connected_medication_management_October_2021.a8fbd059.pdf";